export default __webpack_public_path__ + "static/media/icon-arrow-down.979ef07a.svg";